//import style global sheet
import '@moeindal/base-raiko-panel-components/dist/cjs/index.css';

import './style/App.css';
import './style/Font.css';
import './style/Scrollbar.scss';
import './style/TextFieldStyle.css'
import './style/CustomizeComponents.css'
import './style/FlexStyle.css'
import './style/TableStyle.scss'
import "./style/Containers.css"
import "./style/ModalStyleSheet.css"
import "./style/CardStyleSheet.scss"
import "./style/Icons.scss"
import "./style/SelectionStyleSheet.css"


//import library
import {ThemeProvider} from '@mui/material';
import {Navigate, Route, Routes} from "react-router-dom";
import CustomTheme from "./theme/CustomTheme";
import PrivateRoute from "./route/PrivateRoute";
import React from "react";
import {RouteInfo} from "./route/RouteHelper";

import {prefixer} from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import {CacheProvider} from "@emotion/react";
import {ThemeColor} from "./component/ThemeToggle/ThemeColorToggle";
// import SignUp from "./pages/signUp/SignUp";
import SignIn from "./pages/signIn/SignIn";


const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin]
});

function App() {

    const body = document.body
    const lightTheme = "light"
    const darkTheme = "dark"

    let theme;
    let themeColor = ""

    if (localStorage) {
        theme = localStorage.getItem("theme")
        themeColor = localStorage.getItem("themeColor");
    }

    if (theme === lightTheme || theme === darkTheme) {
        body.classList.add(theme)
    } else {
        theme = lightTheme
        body.classList.add(lightTheme)
    }

    // if (themeColor && themeColor.length > 0) {
    //     body.classList.add(themeColor);
    // } else {
    //     themeColor = ThemeColor.Green;
    //     body.classList.add(themeColor);
    // }
    themeColor = ThemeColor.Green;
    body.classList.add(themeColor);

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={CustomTheme}>
                <div>
                    <Routes>
                        {/*<Route element={<SignUp/>} path={"/panel/signUp/*"}/>*/}
                        <Route element={<SignIn/>} path={RouteInfo.SignIn.url}/>
                        <Route
                            path='/panel/*'
                            element={
                                <PrivateRoute/>
                            }
                        />
                        <Route path="*" element={<Navigate replace to="/panel/"/>}/>
                    </Routes>
                </div>

                {/*<PwaInstallPrompt/>*/}
            </ThemeProvider>
        </CacheProvider>
    );
}

export default App;
